import { Subscription } from 'rxjs';
import { EventService } from '../services/event-service';
import { Directive, ElementRef, Output, EventEmitter, Input, SimpleChanges, OnChanges, OnInit, OnDestroy } from '@angular/core';

@Directive({
	selector: '[clickOutside]'
})

export class ClickOutsideDirective implements OnChanges, OnInit, OnDestroy {
	@Input('clickOutsideActive') active: boolean;
	@Input() clickOutsideExclude: HTMLElement;
	@Input() clickOutsideExcludeQueries: string[];

	@Output() clickOutside = new EventEmitter<MouseEvent>();

	private documentMouseUpSubscription: Subscription;

	constructor(
		private el: ElementRef,
		private eventService: EventService
	) {
		this.active = true;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.active) {
			if (changes.active.currentValue === true) {
				// listen to eventService for documentMouseUp
				this.startListeningToDocumentMouseUp();
			} else {
				// stop listening to eventService for documentMouseUp
				this.stopListeningToDocumentMouseUp();
			}
		} else {
			// stop listening to eventService for documentMouseUp
			this.stopListeningToDocumentMouseUp();
		}
	}

	ngOnInit() {
		if (this.active) {
			this.startListeningToDocumentMouseUp();
		}
	}

	ngOnDestroy() {
		this.stopListeningToDocumentMouseUp();
	}

	private startListeningToDocumentMouseUp() {
		this.documentMouseUpSubscription = this.eventService.documentMouseUpEvent.subscribe((evt: MouseEvent) => {
			this.handleMouseUpOutside(evt, evt.target as HTMLSelectElement);
		});
	}

	private stopListeningToDocumentMouseUp() {
		if (this.documentMouseUpSubscription != null) {
			this.documentMouseUpSubscription.unsubscribe();
		}
	}

	private handleMouseUpOutside(event: MouseEvent, targetElement: HTMLElement): void {
		if (!targetElement || event.button !== 0) {
			return;
		}

		const clickedInside = this.el.nativeElement.contains(targetElement);
		let clickedExclude = this.clickOutsideExclude && this.clickOutsideExclude.contains(targetElement);
		if (this.clickOutsideExcludeQueries && this.clickOutsideExcludeQueries.length) {
			this.clickOutsideExcludeQueries.forEach((query) => {
				const el = document.querySelector(query);
				if (el && el.contains(targetElement)) {
					clickedExclude = true;
				}
			});
		}
		if (!clickedInside && !clickedExclude) {
			this.clickOutside.emit(event);
		}
	}
}
